import News from '~/news/components/News'
import NewsArticle from '~/news/components/NewsArticle'
import Community from '~/community/components/Community'
import SubBands from '~/community/components/SubBands'
import SubDiscounts from '~/community/components/SubDiscounts'
import Programs from '~/programs/components/Programs'
import Grid from '~/programs/components/Grid'
import Lineup from '~/programs/components/Lineup'
import Forms from '~/nodes/components/Forms'
import Hot100 from '~/features/components/Hot100'
import Hot100Archive from '~/features/components/Hot100Archive'
import Top20 from '~/features/components/Top20'
import Node from '~/nodes/components/Node'
import Merch from '~/views/Merch'
//import Main from '~/main/components/Main'
import MainRedesign from '~/main/components/MainRedesign'
import Radiothon2022 from '~/main/components/Radiothon2022'
import Radiothon2023 from '~/main/components/Radiothon2023'
import RadiothonBanner2023 from '~/main/components/RadiothonBanner2023'
import Main from '~/main/components/MainRedesign'
import Show from '~/programs/components/ShowHOC'
import Reviews from '~/reviews/components/Reviews'
import Review from '~/reviews/components/Review'
import Albums from '~/reviews/components/Albums'
import Album from '~/reviews/components/Album'
import AmrapPages from '~/programs/components/AmrapPages'
import NotFound from '~/app/components/NotFound'
import BNAs from '~/nodes/components/BNAs'
import Events from '~/main/components/Events'
import FiftyEvents from '~/main/components/FiftyEvents'
import AnnouncersTopTen from '~/features/components/AnnouncersTopTen'
import Radiothon from './features/components/Radiothon'
import AprilAtonement from './features/components/AprilAtonement'
import FromAToTripleZed from '~/features/components/FromAToTripleZed';
import MonthlySubscriberPrizeDraw from '~/features/components/MonthlySubscriberPrizeDraw'
import Test from '~/features/components/Test'
import Top20Feature from './main/components/Top20Feature'

const routes = [
	{ path: '/news', exact: true, component: News },
  { path: '/news/:id', component: NewsArticle },
  { path: '/programs', component: Programs },
  { path: '/grid/:station?', component: Grid },
  { path: '/form', component: Forms },
  // { path: '/hot100', component: Node },
  { path: '/hot100-archive', component: Hot100Archive },
  { path: '/hot100', component: Hot100 },
	{ path: '/top20', component: Top20Feature },
  { path: '/lineup', component: Lineup },
  { path: '/faqs', component: Node },
  { path: '/about', component: Node },
  { path: '/contacts', component: Node },
  { path: '/participate', component: Node },
  { path: '/training', component: Node },
  { path: '/subscribe', component: Node },
  { path: '/sces', component: Node },
  { path: '/march-music-month', component: Node },
  { path: '/subscriber(s)?/bands/:id?', component: SubBands },
  { path: '/subscriber(s)?/discounters/:type?/:id?', component: SubDiscounts },
  { path: '/community/:type?/:id?', component: Community },
  { path: '/governance', component: Node },
  { path: '/podcasts', component: FromAToTripleZed },
  { path: '/april-atonement', component: AprilAtonement },
  { path: '/monthly-subscriber-prize-draw', component: MonthlySubscriberPrizeDraw },
  // { path: '/radiothon', component: Radiothon },
  { path: '/radiothon', component: Radiothon },
  // { path: '/merch', component: Merch },
{ path: '/', exact: true, component: MainRedesign },
  { path: '/program/:id/:date?', component: Show },
  { path: '/reviews/album(s)?/:id?', component: Albums, routes:
    [
      { path: '/reviews/album/:id', component: Album }
    ]
  },
  { path: '/reviews/:type?/:id?', component: Reviews },
  { path: '/zed-announcers-top-tens/:id?', component: AnnouncersTopTen },
  { path: '/amrap/:id?', component: AmrapPages },
  { path: '/best-new-arrivals/:id?', component: BNAs },
  { path: '/event(s)?/:id?', component: FiftyEvents, routes:
    [
      { path: '/events', component: FiftyEvents }
    ]
  },
    { path: '/4ZZZ50/:id?', component: FiftyEvents, routes:
    [
      { path: '/4ZZZ50', component: FiftyEvents }
    ]
  },
  { path: '/test', component: Test },
  { path: '*', component: Node }

]

export default routes
